import { Add, BorderColor, Star, Warning } from "@mui/icons-material"
import { Box, Card, Divider, SxProps, Typography } from "@mui/material"
import { Activity } from "components/planner/types"
import { FunctionComponent, useMemo } from "react"
import { TOOLTIP_ALERT, tooltipCycleFromActivity } from "stores/planner/utils/tooltip"
import theme from "styles/theme"
import ProductionIcon from "images/ai"



type Props = {
	activity: Activity
	pos: Pos
}
type Pos = { x: number, y: number }

/**
 * Visualizza in un punto "pos" delle informazioni facendo apparire un tooltip
 * nello specifico i CROP_LOTS 
  */
const TooltipCycle: FunctionComponent<Props> = ({
	activity,
	pos,
}) => {
	// HOOKS
	const tooltip = useMemo(() => tooltipCycleFromActivity(activity), [activity])

	// RENDER
	if (!tooltip) return null

	return <Box sx={getCssRoot(pos)}>

		<Card elevation={2} sx={cssCard}>
			<Box sx={cssContainer}>

				{tooltip.title && (
					<Box sx={{ fontSize: 14, fontWeight: 500 }}>
						{tooltip.title}
					</Box>
				)}

				{tooltip.phase && <Box sx={{ display: "flex", gap: "3px", alignItems: "center" }} >
					<Box sx={{ fontSize: 11, fontWeight: 300, textTransform: "uppercase" }}>
						{tooltip.phase}
					</Box>
					<Box sx={{ fontSize: 10, fontWeight: 500, bgcolor: theme.palette.secondary.main, color: theme.palette.secondary.contrastText, p: "0px 5px 1px 5px", borderRadius: "3px" }}>
						{tooltip.layerName}
					</Box>
				</Box>}

				<Divider sx={{ my: "3px" }} />

				{tooltip.rows?.map((row, index) =>
					<Typography key={index} variant="caption">
						{row}
					</Typography>
				)}

				{tooltip.alerts.length > 0 && <Divider sx={{ my: "3px" }} />}
				{tooltip.alerts.map((alert, index) => (
					<Box key={index} sx={cssAlertRow(alert.type)}>
						{{
							[TOOLTIP_ALERT.OVERLAP]: <Warning sx={{ width: "14px" }} />,
							[TOOLTIP_ALERT.NEW]: <Add sx={{ width: "14px" }} />,
							[TOOLTIP_ALERT.MODIFIED]: <BorderColor sx={{ width: "14px" }} />,
							[TOOLTIP_ALERT.PRODUCTION]: <Star sx={{ width: "14px" }} />,
							[TOOLTIP_ALERT.AI]: <ProductionIcon style={{ width: "14px" }} />,
						}[alert.type]}
						<Box sx={cssWarning}>{alert.label}</Box>
					</Box>
				))}
			</Box>
		</Card>

		<svg width="36" height="17" viewBox="0 0 36 17" xmlns="http://www.w3.org/2000/svg">
			<path d="M17.5 16L34 1L2 0.999997L17.5 16Z" fill="#2b2b2b" />
		</svg>
	</Box>
}
export default TooltipCycle


const getCssRoot = (pos: Pos): SxProps => ({
	display: "flex", flexDirection: "column", alignItems: "center",
	top: pos.y, left: pos.x,
	position: "absolute",
	transform: "translate(-50%, calc( -10px - (100%) ))",
})

const cssCard: SxProps = {
	padding: "10px",
	marginBottom: "-9px",
}

const cssContainer: SxProps = {
	display: "flex", flexDirection: "column",
}

const cssAlertRow = (type: TOOLTIP_ALERT): SxProps => ({
	display: "flex",
	alignItems: "center",
	color: {
		[TOOLTIP_ALERT.MODIFIED]: theme.palette.secondary.main,
		[TOOLTIP_ALERT.NEW]: theme.palette.primary.main,
		[TOOLTIP_ALERT.OVERLAP]: theme.palette.error.main,
		[TOOLTIP_ALERT.PRODUCTION]: theme.palette.text.main,
		[TOOLTIP_ALERT.AI]: theme.palette.text.main,
	}[type],
})
const cssWarning: SxProps = {
	fontSize: "12px",
	fontWeight: 500,
}